<template>
    <div class="page-royaume" :class="diapoZoom?'diapo-zoom':''">

        <div class="diaporama">
            <diaporama :medias="royaume.diaporama"></diaporama>

            <a href="#" class="btn-fs" @click.prevent="diapoZoom=!diapoZoom">
                <icon-base v-if="!diapoZoom" size="2vw" icon-color="#fff">
                    <icon-zoom ></icon-zoom>
                </icon-base>
            </a>

        </div>

        <div class="texts">
            <h1>{{royaume.title}}</h1>
            <div class="texts-container">
                <div>
                    <h2>Histoire du royaume</h2>
                    <p>{{royaume.histoiretxt}}</p>
                </div>
                <div>
                    <h2>Système d'organisation</h2>
                    <p>{{royaume.organisationtxt}}</p>
                </div>
                <div>
                    <h2>Fokos présents sur le territoire</h2>
                    <p>{{royaume.fokos.txt}}</p>
                </div>
                <map-loader
                        class="the-map"
                        :src="royaume.fokos.map.src"
                        :points="royaume.fokos.list"
                        small
                ></map-loader>
            </div>
        </div>

        <a class="btn-close"
           href="#"
           @click.prevent="closeClick"
        >
            <icon-base size="4vw" icon-color="#fff">
                <icon-close></icon-close>
            </icon-base>
        </a>

    </div>
</template>

<script>
    import DB from "shared-src/data/DB";
    import IconBase from "shared-src/icons/IconBase";
    import IconClose from "shared-src/icons/IconClose";
    import IconZoom from "shared-src/icons/IconZoom";
    //import LegendeDeco from "shared-src/comp/LegendeDeco";
    import Diaporama from "../components/diaporama/Diaporama";
    import MapLoader from "../components/map/MapLoader";
    export default {
        name: "PageRoyaume",
        components:{
            MapLoader,
            Diaporama,
            IconBase,
            IconClose,
            IconZoom
        },
        data() {
            return {
                /**
                 * @type {PageRoyaumeModel}
                 */
                royaume:null,
                langCode:this.$store.state.language,
                diapoZoom:false
            }
        },
        created() {
            console.log("created royaume");
            this.royaume=DB.inst.getModel("royaume",this.$router.currentRoute.params.id);
        },
        methods:{
            closeClick(){
                if(this.diapoZoom){
                    this.diapoZoom=false;
                }else{
                    this.$router.push("/"+this.langCode+"/map")
                }
            }
        }
    }
</script>

<style lang="less">
    .page-royaume{

        @iconMargin:2vw;

        >.diaporama,.texts{
            position: absolute;
            height: 100%;
            width: 50%;
        }
        >.btn-close{
            z-index: 1;
            position: absolute;
            top: @iconMargin;
            right: @iconMargin;
            svg{
                pointer-events: none;
            }
        }
        >.diaporama{
            z-index: 1;
            background-color: #333333;
            left: 0;
            .btn-fs{
                z-index: 2;
                position: absolute;
                top: 3vw;
                right: 2.5vw;
            }

        }
        >.texts{
            background: #a41b2f url("../assets/textures/bg-texture-rouge.jpg");
            background-size: cover;
            right: 0;
            //overflow-y: auto;

            overflow-y: overlay;

          //height: 90%;



            >h1{
                display: flex;
                //justify-content: flex-end;
                align-items: flex-end;
                margin: 5vw 3vw 2vw 6vw;
                //outline: 1px solid red;
                height: 14vw;
                font-size: 3.5vw;
            }
            >.texts-container{
                position: relative;

                &:before{
                    content: "";
                    display: block;
                    height: 4px;
                    background-color: #fff;
                    width: 24vw;
                    position: absolute;
                    top: 0;
                    left: -12.5vw;
                }

                border-left: 1px solid #fff;
                margin-left: 12.5vw;
                padding: 3vw 8vw 4vw 3vw;
                >div{
                    >h2{
                        margin-bottom: 0.5vw;
                    }
                    >p{
                        margin-bottom: 3vw;
                    }
                }

                .map-loader{
                    width: 50%;
                    margin-left: auto;
                    margin-right: auto;
                }
            }
        }

        >.diaporama{
            will-change: width;
            transition: width 0.5s;
        }
        >.texts{
            will-change: right;
            transition: right 0.5s;
        }

        &.diapo-zoom{
            >.diaporama{
                width: 100%;
            }
            >.texts{
                right: -50vw;
            }
        }
    }

</style>